import { useFlags } from '@mint-lib/routing-context';

export const useImportHubV2 = () => {
  const ff = useFlags('@mint/arm', ['importHubV2']);

  return ff.importHubV2.enabled;
};
